import { useState } from "react";

import { useListProductEarsQuery } from "api/memberPortal/product/product.api";
import EarProductTable from "features/memberPortal/EAR/components/EarProductTable/EarProductTable.table";
import { useAuth } from "hooks/useAuth";

import AddEarForm from "../modals/EarAddModal/AddEar.modal";

export default function EARDetailsAccordion({
  id,
}: {
  id: string | undefined;
}) {
  const [show, setShow] = useState(false);
  const { permissions } = useAuth();

  const onShow = () => {
    setShow(true);
  };

  const onHide = () => {
    setShow(false);
  };

  const [tableParams, _setTableParams] = useState({
    ordering: "-earid",
    limit: 200,
  });

  const { data: productEars, isFetching: isFetchingProductEars } =
    useListProductEarsQuery({
      productId: id,
      params: tableParams,
    });

  return (
    <>
      <AddEarForm show={show} onHide={onHide} product_id={id} />
      <EarProductTable
        ears={productEars}
        isLoading={isFetchingProductEars}
        onAdd={permissions.role_type === "Lab" ? undefined : onShow}
      />
    </>
  );
}
